'use strict';//Indicating browser should run only in java script mode
; (function () {
    angular.module('EMR.DepressionScreeningMoreActionsModule', []);

    var depressionScreeningMoreActionsModuleRoutes = [

        {
            "name": "DepressionScreeningMoreActionsPopup",
            "url": "DepressionScreeningMoreActionsPopup",
            "templateUrl": "AngularScripts/DepressionScreeningMoreActions/Htmls/DepressionScreeningMoreActionsPopup.html",
            "RoutingNumber": 4684,
            files: [
                "AngularScripts/DepressionScreeningMoreActions/Services/DepressionScreeningMoreActionsService.js",
                "AngularScripts/EhrAgGridHandler/Factories/EhrAgGridHandlerFactory.js",
                "AngularScripts/DepressionScreeningMoreActions/Controllers/DepressionScreeningMoreActionsPopupController.js",
            ]
        },

    ];
    angular.module('EMR.DepressionScreeningMoreActionsModule')
        .constant("depressionScreeningMoreActionsModuleRoutes", depressionScreeningMoreActionsModuleRoutes)
        .config(["$stateProvider", "EmrRouteProvider", "depressionScreeningMoreActionsModuleRoutes",
            function ($stateProvider, EmrRouteProvider, depressionScreeningMoreActionsModuleRoutes) {
                debugger;
                EmrRouteProvider.registerStates(depressionScreeningMoreActionsModuleRoutes, $stateProvider);
            }]);
})();
